import React, { useEffect } from 'react';

import { CircularProgress, Container, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

import { useLoadIncidentCallback, useGotoListPageCallback, useLoadFilterCallback } from '../../states/incidents';

import Button from '@mui/material/Button';
import IncidentResolutionContainer from './resolve';
import ShipmentProfile from '../ShipmentProfile';

export default function IncidentDetailContainer() {
  const params = useParams();
  const loadIncident = useLoadIncidentCallback();
  const gotoList = useGotoListPageCallback();
  const loadFilter = useLoadFilterCallback();

  useEffect(() => {
    loadIncident(params.id);
    loadFilter();
  }, [loadIncident, loadFilter, params.id]);

  const goBack = () => {
    gotoList();
  };

  return (
    <Container maxWidth={false} style={{ height: 'calc(100% - 65px)', paddingTop: '10px' }}>
      <Paper elevation={2}>
        <Container maxWidth={false} style={{ padding: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={goBack} disableElevation size='small' color='inherit'>
            Back
          </Button>
          <React.Suspense fallback={<CircularProgress />}>
            <IncidentResolutionContainer type={params.type} />
          </React.Suspense>
        </Container>
        <Container maxWidth={false} style={{ padding: '15px' }}>
          <ShipmentProfile />
        </Container>
      </Paper>
    </Container>
  );
}
